import MiSwitch from './MiSwitch.vue'

export default MiSwitch
